module.exports = __webpack_public_path__ + "static/media/happy.cceb7c82.jpg";